export default function AuthLoadingCard() {
  return (
    <div className="card" style={{ padding: "48px", textAlign: "center" }}>
      Laster inn brukerprofil...
    </div>
  );
}
